import { ExternalRecordLink } from "components/home-care-leads/send-to-partner/external-record-link";
import { InteractiveTextLink } from "components/ui/interactive-text-link";
import { PanelType } from "components/ui/panel/panel-type";
import { ResponsivePanel } from "components/ui/panel/responsive-panel";
import React, { useCallback, useState } from "react";
import {
    PartnerSyncDetails,
    PartnerSyncProps,
    PartnerSyncState,
} from "./partner-sync-status";

export const PartnerSyncIndicator: React.FC<PartnerSyncProps> = ({
    partnerName,
    url,
    status,
    syncNow,
    now,
}) => {
    const [showingDetails, setShowingDetails] = useState(false);
    const showDetails = useCallback(() => setShowingDetails(true), []);
    const hideDetails = useCallback(() => setShowingDetails(false), []);

    return (
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
            {url ? <ExternalRecordLink url={url} partnerName={partnerName} /> : null}
            <span className="inline-flex flex-wrap items-center gap-x-2 text-sm text-gray-500">
                {status.current ? (
                    <>
                        <PartnerSyncState current={status.current} now={now} />
                        <span aria-hidden="true">·</span>
                    </>
                ) : null}
                <InteractiveTextLink
                    className="text-sm font-medium"
                    aria-label={`View ${partnerName} sync details`}
                    onClick={showDetails}>
                    Details
                </InteractiveTextLink>
            </span>
            <ResponsivePanel
                isOpen={showingDetails}
                onDismiss={hideDetails}
                type={PanelType.medium}
                headerText={`${partnerName} sync`}>
                <PartnerSyncDetails
                    partnerName={partnerName}
                    url={url}
                    status={status}
                    syncNow={syncNow}
                    now={now}
                />
            </ResponsivePanel>
        </div>
    );
};
